import React, { useEffect, useState } from 'react'
import { Button, Space, Breadcrumb, Form, Modal, Drawer, Col } from 'antd'
import {
  formatUrl,
  carOrdersUrl,
  shippingCompaniesUrl,
  postRequest,
  getRequest
} from '../../config'
import FilterTable from '../../components/Forms/searchFilter'
import PageLoader from '../../components/Layouts/PageLoader'
import BasicInput from '../../components/Forms/BasicInput'
import SelectInput from '../../components/Forms/SelectInput'
import WithData from 'hocs/WithData'
import { ORDER_DELIVERY_STATUSES, ORDER_STATUSES } from 'app-constants'
import Update from './Update'
import { columns } from './tableColumns'
import PageTitle from 'components/PageTitle'

const Order = props => {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false)
  const [meta, setMeta] = useState({
    previous: null,
    next: null,
    count: 0
  })
  const [phoneNumber, setPhoneNumber] = useState('')
  const [paymentStatus, setPaymentStatus] = useState('')
  const [deliveryStatus, setDeliveryStatus] = useState('')
  const [createdBy, setCreatedBy] = useState('')
  const [shippingCompany, setShippingCompany] = useState('')
  const [containerNumber, setContainerNumber] = useState('')

  const [shippingCompaniesLoading, setShippingCompaniesLoading] = useState(
    false
  )
  const [shippingCompanies, setShippingCompanies] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showFilters, setShowFilters] = useState(false)
  const [modalKey, setModalKey] = useState(1)
  const [currentOrder, setCurrentOrder] = useState({})
  // const [currentUrl, setCurrentUrl] = useState('')

  const handlePhoneChange = event => {
    setPhoneNumber(event.target.value)
  }

  const handleSelectStatus = value => {
    setPaymentStatus(value)
  }

  const handleSelectDeliveryStatus = value => {
    setDeliveryStatus(value)
  }

  const handleSelectShippingCompany = value => {
    setShippingCompany(value)
  }

  const handleSelectCreatedBy = value => {
    setCreatedBy(value)
  }

  const handleContainerNumberChange = event => {
    setContainerNumber(event.target.value)
  }

  const searchOrders = async customUrl => {
    let url = customUrl ? formatUrl(customUrl) : `${carOrdersUrl}/search`
    // setCurrentUrl(url)
    const response = await postRequest(
      url,
      {
        phoneNumber,
        paymentStatus,
        deliveryStatus,
        createdBy,
        shippingCompany,
        containerNumber
      },
      'orders',
      setLoading
    )
    if (response.success) {
      setOrders(response.data.results)
      setMeta({
        ...response.data,
        results: response.data.results.length
      })
    }
  }

  const getShippingCompanies = async () => {
    const response = await getRequest(
      shippingCompaniesUrl,
      'shipping companies',
      setShippingCompaniesLoading
    )
    if (response.success) {
      setShippingCompanies(
        response.data.results.map(ship => {
          return {
            ...ship,
            label: `${ship.name} - ${ship.origin.country}`,
            value: ship.id
          }
        })
      )
    }
  }

  useEffect(() => {
    searchOrders('')
    getShippingCompanies()
    // eslint-disable-next-line
  }, [])

  const handleSuccess = order => {
    let updatedOrders = orders.map(prod => {
      if (prod.id === order.id) {
        return order
      } else {
        return prod
      }
    })
    setOrders(updatedOrders)
  }

  useEffect(() => {
    if (showModal) {
      setModalKey(modalKey + 1)
    }
    // eslint-disable-next-line
  }, [showModal])

  return (
    <PageLoader className="container" loading={loading}>
      <PageTitle title="Car orders" />
      <div className="row">
        <div className="col-lg-12">
          <Breadcrumb>
            <Breadcrumb.Item href="/">
              {/* <HomeOutlined /> */}
              <span>Home</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Car Orders</Breadcrumb.Item>
          </Breadcrumb>
          <br />
          <br />
          <div className="card mb-4rem">
            <div className="card-header">
              <div className="utils__title">
                <span>Car Orders</span>
              </div>
            </div>
            <div className="card-body">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '1rem',
                  width: '100%'
                }}
              >
                <Button
                  type="primary"
                  // eslint-disable-next-line react/prop-types
                  onClick={() => props.history.push('/car-orders/add-new')}
                >
                  Add New Order
                </Button>

                <Button type="default" onClick={() => setShowFilters(true)}>
                  Apply Filters
                </Button>
              </div>
              <FilterTable
                dataSource={orders}
                columns={columns(setCurrentOrder, setShowModal)}
                // searchFields={['name', 'partnerBranch', 'status']}
                meta={meta}
                getData={url => searchOrders(url)}
              />

              <Modal
                title="Update Car Order Details"
                centered
                open={showModal}
                onOk={() => setShowModal(false)}
                onCancel={() => setShowModal(false)}
                footer={null}
                width={700}
              >
                <Update
                  key={modalKey}
                  order={currentOrder}
                  handleCancel={order => {
                    setShowModal(false)
                    handleSuccess(order)
                  }}
                />
              </Modal>

              <Drawer
                title={'Apply Filters'}
                placement="right"
                open={showFilters}
                closable={true}
                onClose={() => setShowFilters(false)}
                key={'right'}
              >
                <div className="my-4">
                  <Form layout="vertical">
                    <div>
                      <SelectInput
                        placeholder=""
                        label="Select payment status"
                        name="status"
                        value={paymentStatus}
                        onChange={handleSelectStatus}
                        style={{ width: '100%' }}
                        optionList={[
                          { label: 'all payment statuses', value: '' },
                          ...ORDER_STATUSES
                        ]}
                      />
                    </div>

                    <div>
                      <SelectInput
                        placeholder=""
                        label="Select delivery status"
                        name="deliveryStatus"
                        value={deliveryStatus}
                        onChange={handleSelectDeliveryStatus}
                        style={{ width: '100%' }}
                        optionList={[
                          { label: 'all delivery statuses', value: '' },
                          ...ORDER_DELIVERY_STATUSES
                        ]}
                      />
                    </div>

                    <div>
                      <SelectInput
                        placeholder="Select shipping company"
                        label="Choose shipping company"
                        name="shipping company"
                        value={shippingCompany}
                        onChange={handleSelectShippingCompany}
                        optionList={[
                          {
                            label: '>>>all shipping companies<<<',
                            value: ''
                          },
                          ...shippingCompanies
                        ]}
                        loading={shippingCompaniesLoading}
                      />
                    </div>

                    <div>
                      <SelectInput
                        placeholder=""
                        label="Order initiated by"
                        name="createdby"
                        value={createdBy}
                        onChange={handleSelectCreatedBy}
                        optionList={[
                          {
                            label: '>>>all orders<<<',
                            value: ''
                          },
                          {
                            label: 'Created by Admins',
                            value: 'ADMIN'
                          },
                          {
                            label: 'Created by Users',
                            value: 'USER'
                          }
                        ]}
                      />
                    </div>
                    <div>
                      <BasicInput
                        label="Container or B/L number"
                        value={containerNumber}
                        name={'containerNumber'}
                        placeholder="container number"
                        handleChange={handleContainerNumberChange}
                      />
                    </div>
                    <div>
                      <BasicInput
                        label="Customer's phone number"
                        value={phoneNumber}
                        name={'customer'}
                        placeholder="customer's phone number"
                        handleChange={handlePhoneChange}
                      />
                    </div>
                    <div>
                      <Col md={24}>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            marginBottom: '20px'
                          }}
                        >
                          <Space>
                            {/* eslint-disable-next-line react/prop-types */}
                            <Button onClick={() => props.history.goBack()}>
                              Go Back
                            </Button>
                            <Button
                              type="primary"
                              onClick={() => searchOrders('')}
                              loading={loading}
                            >
                              Submit
                            </Button>
                          </Space>
                        </div>
                      </Col>
                    </div>
                  </Form>
                </div>
              </Drawer>
            </div>
          </div>
        </div>
      </div>
    </PageLoader>
  )
}

export default WithData(Order)
